import type { ErrorReport } from '../../types';

type P = {
  errorSummary: ErrorReport['errorSummary'];
};

export const useGetErrorItems = ({ errorSummary }: P) => [
  { children: errorSummary.name, key: 'name', label: 'Error name' },
  { children: errorSummary.message, key: 'message', label: 'Message' },
];
